import React, { type FC } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import KC_Modal_2 from "../../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import "./styles.scss";

interface Props {}

const UnsubscribeConfirmationModal: FC<Props & NiceModalHocProps> =
  NiceModal.create<Props>((props) => {
    const modal = useModal();

    const handleResponse = (confirmed: boolean) => {
      modal.resolve(confirmed);
      void modal.hide();
    };

    return (
      <KC_Modal_2
        id="unsubscribe-confirmation-modal"
        isOpen={modal.visible}
        onClose={() => handleResponse(false)}
        hideCloseButton={true}
        header={
          <div className={"w-100 py-2 px-3"}>
            <KC_Heading3 text={tt("unsubscribe_confirm_title")} />
          </div>
        }
        footer={
          <div className="d-flex flex-grow-1 align-items-center justify-content-end st-gap">
            <KC_Button
              id="unsubscribe-confirm-no"
              isPrimary={true}
              onClick={() => handleResponse(false)}
              size={KC_ButtonSize.Large}
              text={tt("no")}
              className="d-flex"
            />
            <KC_Button
              id="unsubscribe-confirm-yes"
              isPrimary={false}
              isInverted={true}
              onClick={() => handleResponse(true)}
              size={KC_ButtonSize.Large}
              text={tt("yes")}
              className="d-flex"
            />
          </div>
        }
      >
        <div className="p-4 text-center" style={{ minHeight: 100 }}>
          <KC_UIText
            weight={KC_Weights.reg}
            text={tt("unsubscribe_confirm_message")}
          />
        </div>
      </KC_Modal_2>
    );
  });

export default UnsubscribeConfirmationModal;
